
import moment from 'moment'
import api from '@/api/api'
import WechatShare from '@/components/WechatShare/WechatShare'
import Previewer from '@/components/XPreview/XPreview'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
  directives: {
    TransferDom
  },
  data() {
    return {
      likeDisabled: false,
      showConfirm: false,
      confirm_title: '',
      onConfirm: '',
      isAct: false,
      fetchDisabled: false,
      pageIndex: 1,
      pageSize: 5,
      liveId: 0,
      content: '',
      currentCommentId: '',
      currentCommentIndex: 0,
      showComment: false,
      commentPageIndex: 1,
      interactionList: [],
      scrollDisabled: false,
      loadMessage: '努力加载中 ...',
      previewerList: [],
      options: {
        bgOpacity: 0.9,
        loop: false,
        clickToCloseNonZoomable: false,
        tapToClose: false,
        isClickableElement: function(el) {
          if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1) {
            return true
          } else {
            return false
          }
        },
        errorMsg: '<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
      }
    }
  },
  components: {
    Previewer,
    Popup,
    XButton,
    XTextarea,
    Group,
    Confirm,
    WechatShare
  },
  computed: {
    list() {
      return this.$store.state.live.interactionList.Result
    },
    live() {
      return this.$store.state.live.detail
    },
    interactionCount() {
      return this.$store.state.live.interactionList.Total
    }
  },
  methods: {
    onCancel() {
      console.log('on cancel')
    },
    onHide() {
      console.log('on hide')
    },
    onShow() {
      console.log('on show')
    },
    // 点赞操作
    like(id, index) {
      let u = JSON.parse(window.localStorage.user)
      if (!this.likeDisabled) {
        this.likeDisabled = true
        // 判断是否已经点赞
        if (this.interactionList[index].isLiked) {
          // 已经点过赞
          // 数据库取消点赞
          api.live.unLike(id)
            .then(() => {
              this.$vux.toast.show({
                text: '已取消赞'
              })
              // 熄灭按钮
              this.interactionList[index].isLiked = false
              // 更新点赞数
              this.interactionList[index].LikesCount--
              // 点赞列表中移除id为操作者的对象
              let result = this.interactionList[index].likeInfo.data.Result
              let rmIndex = 0
              result.map((item, i) => {
                if (item.Id == JSON.parse(window.localStorage.user).Id) {
                  // 取出索引
                  rmIndex = i
                }
              })
              this.interactionList[index].likeInfo.data.Result.splice(rmIndex, 1)
              setTimeout(() => {
                this.likeDisabled = false
              }, 2000)
            })
        } else {
          // 没有点过
          // 数据库插入点赞数据
          api.live.like(id)
            .then(() => {
              this.$vux.toast.show({
                text: '已赞'
              })
              // 点亮按钮
              this.interactionList[index].isLiked = true
              // 更新点赞数
              this.interactionList[index].LikesCount++
              // 点赞列表中加入id为操作者的对象
              this.interactionList[index].likeInfo.data.Result.unshift({
                Nickname: u.Nickname,
                Avatar: u.Avatar
              })
              setTimeout(() => {
                this.likeDisabled = false
              }, 2000)

            })
        }
      }
    },
    // 评论操作
    comment(id, index) {
      this.content = ''
      this.currentCommentId = id
      this.currentCommentIndex = index
      this.showComment = true
    },
    touch() {
      this.isAct = true
    },
    touchend() {
      this.isAct = false
    },
    loadComment(index, interId, data, pageSize) {
      // 更新当前页数
      if (this.interactionList[index].commentInfo.data.PageIndex < data.PageCount) {
        this.interactionList[index].commentInfo.data.PageIndex++
        // 查询下一页内容
        api
          .live
          .getInteractionCommentList(interId, this.interactionList[index].commentInfo.data.PageIndex, pageSize)
          .then(res => {
            if (res.data.Result.length > 0) {
              // 将查询到的结果push到当前数组中
              res.data.Result.map(item => {
                this.interactionList[index].commentInfo.data.Result.push(item)
              })

            }
          })
      }
    },
    fetchMore() {
      if (!this.fetchDisabled) {
        this.fetchDisabled = true
        this.$vux.loading.show({
          text: '正在加载...'
        })
        this.scrollDisabled = true
        this.pageIndex = 1
        this.interactionList = []
        this.loadMessage = '努力加载中 ...'
        this.fetchInteraction()
      }
    },
    show(url, index) {
      let new_url = encodeURIComponent(url)
      let width = document.getElementById(index).width
      let height = document.getElementById(index).height
      // 清空数组，并push新元素进去
      this.previewerList = []
      let item = {
        'w': width * 10,
        'h': height * 10,
        'src': url
      }
      this.previewerList.push(item)
      this.$refs.previewer.show(item)
    },
    loadMore() {
      // 判断页面是否滚动到底部
      if (!this.scrollDisabled && document.documentElement.offsetHeight != 0 && document.documentElement.clientHeight + window.scrollY >= document.documentElement.offsetHeight) {
        // 禁用滚动
        this.scrollDisabled = true
        // 加载数据
        if (this.interactionList.length < this.interactionCount) {
          this.pageIndex++
          this.fetchInteraction()
        } else {
          this.loadMessage = '已经到底了'
        }
      }
    },

    publish() {
      let u = JSON.parse(window.localStorage.user)
      if (this.validate()) {
        // 调用发布接口
        api.live.addComment(this.currentCommentId, this.content)
          .then(cid => {
            // 将评论内容显示到内容中
            this.interactionList[this.currentCommentIndex].commentInfo.data.Result.push({
              Id: cid,
              Content: this.content,
              UserId: u.Id,
              User: {
                Nickname: u.Nickname,
                Avatar: u.Avatar
              }
            })

            // 增加评论数量
            this.interactionList[this.currentCommentIndex].commentInfo.data.Total++

            // 关闭评论窗口
            this.showComment = false
          })

      }
    },
    validate() {
      // 验证输入内容
      if (this.content.length == 0) {
        this.$vux.toast.show({
          type: 'text',
          width: '150px',
          text: '您还没有填写内容哦~'
        })
        return false
      }
      return true
    },
    cancel() {
      this.confirm_title = '确定放弃编辑的内容？'
      this.showConfirm = true
      this.onConfirm = () => this.showComment = false
    },
    fetchInteraction() {
      if (!this.live.Title) {
        // 获取当前对应活动
        this.$store.dispatch({
          type: 'getLiveDetail',
          liveId: this.liveId,
        })
      }
      // 获取当前对应直播的互动信息
      this.$store.dispatch({
        type: 'getInteractionList',
        liveId: this.liveId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }).then(() => {
        this.list.map(item => {
          this.interactionList.push(item)
        })
        // 判断dom是否渲染完毕
        this.$nextTick(() => {
          this.scrollDisabled = false
          this.$vux.loading.hide()
          this.fetchDisabled = false
        })
      })
    },
    dateFormat(time) {
      return moment(time).format('MM月DD日 HH:mm')
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name == 'liveInteraction' && from.name == 'liveInteractionPublish') {
        // 刷新数据
        this.interactionList = []
        this.pageIndex = 1
        this.fetchInteraction()
      }
    }
  },
  mounted() {
    // 监听页面滚动事件
    window.addEventListener('scroll', this.loadMore, false)
    // 获取路由ID
    this.scrollDisabled = true
    this.liveId = this.$route.params.liveId
    // 分页加载此次活动对应的列表页面
    // 每页显示10条数据
    this.fetchInteraction()
  },

}



// WEBPACK FOOTER //
// ./src/components/Interaction/InteractionList.vue